import { type PropsWithChildren } from "react";

import { Button } from "~/components";

export const FIXED_PERCENTAGE_DISCOUNTS = [5, 10, 15, 20, 25, 30, 50, 100];

export const FixedPercentageDiscounts = ({ children }: PropsWithChildren) => {
  return <div className="flex justify-center gap-4 py-2">{children}</div>;
};

const FixedPercentageDiscountButton = ({
  ...props
}: JSX.IntrinsicElements["button"]) => {
  return <Button className="w-14" variant="secondary" {...props} />;
};

FixedPercentageDiscounts.Button = FixedPercentageDiscountButton;
